import React, { useEffect, useState } from "react";
//import axios from '../../../node_modules-back/axios';
import axios from 'axios'
//import { useForm } from '../../../node_modules-back/react-hook-form/dist';
import { useForm } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import { getUrl } from "../../ApiCall/GetUrl";

import ClientTable from "./ClientTable";
import LawyerTable from "./LawyerTable";

import Footer from "../Footer/Footer";
// Importación de los estilos
import "../../styles/Admin.css"


export default function Admin() {

  const [option, setOption] = useState("client");
  const renderContent = () => {
    switch (option) {
      case "client":
        return <ClientTable />
      case "lawyer":
        return <LawyerTable/>
      case "states":
        return;
    }
  }


  const renderFilters = ()=> {
    switch(option) {
      case "client":
        return;
      case "lawyer":
        return;
      case "states":
        return;

    }
  }

  return <>
    <div className="verticalheigh mb-5">
      <div className="mt-5 title">
        <h1>Página de Administrador</h1>
      </div>
      <div className="container-aux mt-5 mb-5">
        <div className="row seleccionador">
          <div className="col" onClick={() => setOption("lawyer")}><a className="letra">Abogados</a></div>
          <div className="col" onClick={() => setOption("client")}><a className="letra">Clientes</a></div>
          <div className="col" onClick={() => setOption("states")}><a className="letra">Estados</a></div>
        </div>
        {renderFilters()}

        {renderContent()}
      </div>
    </div>
    <Footer oscuro={true} />
  </>
}
